import { useEffect, useState } from 'react'
import { NOTICE_VERSION } from './constants'
import { deviceNoticeVersion, rememberNoticeOnDevice } from './storage'
import type { VoiceStatus } from './types'

export interface NoticeGate {
  /** The notice has to be shown before the user can continue. */
  needed: boolean
  /** "Begrepen": the notice is no longer shown during this visit. */
  acknowledge: () => void
}

/**
 * Per user (ED-74, David's decision): the server derives the seen version from the user's
 * captures, the device remembers it so the notice does not flash. Both below the current
 * version shows the notice. Tapping "Begrepen" without saving anything leaves both as they
 * were, so the next visit shows it again; the device cache is only written once the server
 * has seen the version (here, or after the first saved capture in `useOfflineDraft`).
 */
export function useNoticeGate(status: VoiceStatus | null): NoticeGate {
  const [acknowledged, setAcknowledged] = useState(false)
  const serverSeen = status?.notice_seen_version ?? 0
  useEffect(() => {
    if (serverSeen >= NOTICE_VERSION) rememberNoticeOnDevice(NOTICE_VERSION)
  }, [serverSeen])
  const seen = Math.max(serverSeen, deviceNoticeVersion())
  return {
    needed: status !== null && !acknowledged && seen < NOTICE_VERSION,
    acknowledge: () => setAcknowledged(true),
  }
}
